export var getOrigin = function (url) {
    var baseUrl = url.match(/(https?:\/\/.*?)(\/|$)/);
    return baseUrl ? baseUrl[1] : url;
};
export var addSearchParams = function (url, params) {
    if (params === void 0) { params = {}; }
    var enc = encodeURIComponent;
    var searchParams = Object.keys(params).map(function (key) { return "".concat(enc(key), "=").concat(enc(params[key])); });
    if (!searchParams.length) {
        return url;
    }
    var separator = url.includes('?') ? '&' : '?';
    return "".concat(url).concat(separator).concat(searchParams.join('&'));
};
export var encodeRequest = function (data) {
    return Object.keys(data)
        .map(function (key) { return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(data[key])); })
        .join('&');
};
export var decodeResponse = function (body) {
    try {
        var data = JSON.parse(body);
        if (data && data.status) {
            return data;
        }
        return {
            status: 'error',
            description: 'Unknown response'
        };
    }
    catch (err) {
        return {
            status: 'error',
            description: 'Error response decoding'
        };
    }
};
export var encodeParams = function (params) {
    return Object.keys(params).reduce(function (res, key) {
        var value = params[key];
        if (value !== null && value !== undefined) {
            res.push("".concat(key, "=").concat(encodeURIComponent(value)));
        }
        return res;
    }, []);
};
export var buildUrl = function (url, params) {
    if (params === void 0) { params = {}; }
    var encodedParams = encodeParams(params);
    if (encodedParams.length) {
        return "".concat(url, "?").concat(encodedParams.join('&'));
    }
    return url;
};
